import * as React from 'react';
import { SVGProps } from 'react';

const IconCollapseSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 2H8v6H2v2h4v4h2V8h6V6h-4V2z" />
  </svg>
);
export default IconCollapseSizeS;
